// Shared playground state: constants, DOM refs, and mutable editor flags.
// Example: `elements.luisInput`, `state.pendingInputType`.
import { defaultSource } from './defaults'
import { getElement } from './dom'
import { playgroundMessages } from './messages'

export const PLAYGROUND_STYLE_ID = 'lentystyle-playground-style'
export const INCREMENTAL_COMPILE_DELAY_MS = 90

export const elements = {
  luisInput: getElement<HTMLTextAreaElement>('luisInput'),
  luisLineNumbers: getElement<HTMLElement>('luisLineNumbers'),
  cssOutput: getElement<HTMLElement>('cssOutput'),
  cssLineNumbers: getElement<HTMLElement>('cssLineNumbers'),
  status: getElement<HTMLElement>('status'),
  compilePerf: getElement<HTMLElement>('compilePerf'),
  luisStats: getElement<HTMLElement>('luisStats'),
  cssStats: getElement<HTMLElement>('cssStats'),
  languageSelect: getElement<HTMLSelectElement>('languageSelect'),
  compileBtn: getElement<HTMLButtonElement>('compileBtn'),
  applyBtn: getElement<HTMLButtonElement>('applyBtn'),
  htmlInput: getElement<HTMLTextAreaElement>('htmlInput'),
  applyHtmlBtn: getElement<HTMLButtonElement>('applyHtmlBtn'),
  previewMount: getElement<HTMLElement>('previewMount'),
  inputTabLuis: getElement<HTMLButtonElement>('inputTabLuis'),
  inputTabHtml: getElement<HTMLButtonElement>('inputTabHtml'),
  inputPanelLuis: getElement<HTMLElement>('inputPanelLuis'),
  inputPanelHtml: getElement<HTMLElement>('inputPanelHtml'),
  outputPanelCss: getElement<HTMLElement>('outputPanelCss'),
}

export const mutableState = {
  pendingInputType: null as string | null,
  incrementalCompileTimer: null as number | null,
}

// Initialize default editor values on startup.
export function initializeDefaultInputs(): void {
  elements.luisInput.value = defaultSource
  elements.htmlInput.value = playgroundMessages.defaultHtml
}
